import { css } from 'styled-components'

export default css`
  backdrop-filter: blur(32px);
`
